import { Button, Menu } from '@material-ui/core';
import MoreIcon from '@material-ui/icons/MoreVert';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';


export default class SimpleMenu extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            anchorEl: null,
        };
    }
    
    handleOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    
    render() {
        const { anchorEl } = this.state;

        const {
            children,
            id,
            style = {
                margin: '0 5em'
            },
        } = this.props;
    
        return (
            <React.Fragment>
                <Button
                    aria-owns={anchorEl ? `simple-menu-${id}` : null}
                    aria-haspopup="true"
                    onClick={this.handleOpen}
                >
                    <MoreIcon />
                </Button>
                <Menu
                    id={`simple-menu-${id}`}
                    anchorEl={anchorEl}
                    className="moreMenu"
                    open={Boolean(anchorEl)}
                    onClick={this.handleClose}
                    onClose={this.handleClose}
                    PaperProps={{ style }}
                >
                    {children}
                </Menu>
            </React.Fragment>
        )
    }
}

SimpleMenu.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};


// WEBPACK FOOTER //
// ./src/helpers/SimpleMenu.js